// prefer default export if available
const preferDefault = m => m && m.default || m

exports.components = {
  "component---src-pages-index-js": () => import("/tmp/2185727c/src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */)
}

